import { CaretDownFilled } from "@ant-design/icons";
import YudlButton from "../../../components/Button";
import { ROUTES } from "../../../constants";
import "./style.css";

const HeroSection = () => {
  return (
    <section className="hero-section container-md container-fluid d-flex flex-wrap justify-content-betweem">
      <div className="hero-action-container d-flex justify-content-start align-items-center">
        <div>
          <p className="title-small display-6 mb-1">Product Ideas to design</p>
          <p className="display-1 title-big">IN MINUTES</p>
          <div className="hero-button-container d-flex justify-content-md-start justify-content-center my-2 flex-wrap">
            <YudlButton buttonRole="link" link={ROUTES.GETTING_STARTED} children="Get Started" className="m-2" />
            <YudlButton
              buttonRole="anchor"
              link="#how-it-works"
              variant="outline-primary"
              className="m-2"
              children={
                <div className="d-flex align-items-center">
                  <span className="me-1 text-theme">See How it Works</span>{" "}
                  <CaretDownFilled style={{ color: "var(--theme-color)" }} />
                </div>
              }
            />
          </div>
        </div>
      </div>
      <div className="hero-image-section order-md-1 order-2">
        <img src="/assets/landing/home-hero.png" alt="" className="img-fluid" />
      </div>
    </section>
  );
};

export default HeroSection;
